import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import styles from './styles';

interface LoadingSpinnerProps {
  size: number;
}
function LoadingSpinner({ size }: LoadingSpinnerProps): React.ReactElement {
  return (
    <Box sx={styles.spinnerContainer}>
      <CircularProgress size={size} data-testid='spinner' />
    </Box>
  );
}

export default LoadingSpinner;
